import React, { useState } from "react"
import { Form, Input, Button } from "antd"
import { FormattedMessage } from "react-intl"
import { routerHistory } from "../app"
import { setCookie } from "../../shared/helpers/cookie-helper"
import { getLogo } from "../../shared/helpers/logo"
import { DesktopIcon } from "../../shared/icons"
import { getDomainHash, login } from "../../shared/helpers/login"
import { localize } from "../../shared/utils/localize"
import { showErrorNotification } from "../../shared/components/notification"


export const LoginForm = () => {
	const [form] = Form.useForm()
	const [domainName, setDomainName] = useState("")
	const [isLoading, setIsLoading] = useState(false)

	const openApplication = (domain) => {
		routerHistory.push(`/${domain}`)
	}

	const handleSubmit = () => {
		form.validateFields().then(async () => {
			const domain = form.getFieldValue("domain")
			setIsLoading(true)
			const hash = await getDomainHash(domain)
			const res = await login(hash)
			if (res.status === 200) {
				const { domain } = await res.json()
				setCookie("OutbackDomain", domain, 86400)
				setCookie("OutbackHash", hash, 86400)
				await getLogo(domain, hash)
				openApplication(hash)
			} else {
				showErrorNotification(localize("Incorrect domain"))
				setIsLoading(false)
			}
		}).catch(() => {
			setIsLoading(false)
		})
	}

	return (
		<>
			<Form
				form={form}
				onSubmit={handleSubmit}
				className={`login-form ${isLoading ? "custom-loader-spinner-type" : ""}`}
			>
				<Form.Item
					name="domain"
					required
					rules={[{ required: true, message: localize("Please enter domain name") }]}
				>
					<Input
						className={domainName ? "not-empty" : ""}
						prefix={<span className="domain-name" title={localize("Account")} aria-hidden="true"><DesktopIcon /></span>}
						placeholder={localize("Account")}
						aria-label={localize("Account")}
						aria-required="true"
						autoComplete="off"
						allowClear
						onChange={e => setDomainName(e.target.value)}
						onPressEnter={handleSubmit}
					/>
				</Form.Item>
			</Form>
			<div className="login-form-buttons-block">
				<Button type="primary" htmlType="submit" onClick={handleSubmit} aria-label={localize("Login")}>
					<FormattedMessage id="Login" />
				</Button>
			</div>
		</>
	)
}
